export default {
	title: "",
	subtitle: "PIX",
  path: "transaction_pix",
	paragraphs:  [
		"There are two types of PIX payments in Brazil: static and dynamic. First, is important to understand that the PIX payment is only a shortcut for the bank account you have in Brazil.",
		"For Static PIX payments you will share your PIX key with the customer so they can make a payment using this key – usually it is an email or a random key. The customer will pay using their bank account and you will receive it in your account within FacilitaPay. They can choose the amount that will be paid",
		"For this type of payment, you don’t need to create a transaction, only have the customer registered, as soon as we receive the payment, an automatic transaction will be created."
	],
	request: {}
}


// WEBPACK FOOTER //
// ./src/components/documentation/data/Transaction/TransactionPix.js